// DS 표 규칙: No. → 메인(코드 · 버전, 상세 링크) → 데이터 → 상세 아이콘. 폭 없는 칸(코드 · 라벨 · 설명)은 남는 폭을 나눈다
export const columns = [
    { key: 'index', label: 'No.', thClass: 'ds-cell-no', tdClass: 'ds-cell-no' },
    { key: 'code', label: '코드' },
    { key: 'label', label: '라벨' },
    { key: 'description', label: '설명' },
    { key: 'updated_at', label: '수정일시', tdClass: 'ds-cell-nowrap', thStyle: { width: '160px' } },
    { key: 'detail', label: '상세', tdClass: 'text-right', thStyle: { width: '60px' } },
];
